import { useUser } from "apps/vtex/hooks/useUser.ts";
import Icon from "$store/components/ui/Icon.tsx";

export default function AccountButton() {
  const { user } = useUser();
  const isLoggedIn = !!user.value?.email;

  return (
    <div class="pb-3 -mb-3 relative group">
      <a
        class="w-12 h-12 border border-tw-base-50 rounded-full bg-tw-base-50 transition-colors duration-300 flex justify-center items-center relative group-hover:border-tw-primary-100"
        href="/"
        aria-label="Minha conta"
      >
        <Icon id="User" class="text-tw-primary-100" width={21} height={22} />
      </a>

      <div class="px-4 py-2 border border-tw-primary-100 rounded shadow-md opacity-0 bg-white scale-0 transition-opacity duration-300 -translate-x-1/2 absolute top-full left-1/2 z-10 group-hover:opacity-100 group-hover:scale-100">
        <div class="w-3 h-3 border-t border-r border-tw-primary-100 bg-white -rotate-45 -translate-x-1/2 translate-y-1/2 absolute bottom-full left-1/2">
        </div>

        <div class="w-max text-tw-neutral-400 text-center grid gap-3">
          {isLoggedIn
            ? (
              <>
                <a href="/account">Minha conta</a>
                <a href="/account#/orders">Meus pedidos</a>

                <button
                  class="text-tw-danger-200"
                  onClick={async () => {
                    await fetch(
                      `/api/vtexid/pub/logout?scope=tfbmwt&returnUrl=${window.location?.href}`,
                    );

                    window.location?.reload();
                  }}
                >
                  Sair
                </button>
              </>
            )
            : (
              <>
                <a href="/login">Entrar/Cadastrar</a>
                <a href="/account#/orders">Meus pedidos</a>
              </>
            )}
        </div>
      </div>
    </div>
  );
}
